import React from 'react';
import './industries.styles.scss';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { useTranslation } from 'react-i18next';

import retail from '../../../assest/Icons/Industries/commercial.svg';
import credit_cards from '../../../assest/Icons/Industries/finance.svg';
import social from '../../../assest/Icons/Industries/social-media.svg';
import books from '../../../assest/Icons/Industries/education.svg';
import corporate from '../../../assest/Icons/Industries/corporate.svg';
import doc from '../../../assest/Icons/Industries/healthcare.svg';
import utilities from '../../../assest/Icons/Industries/utilities.svg';
import travel from '../../../assest/Icons/Industries/travel.svg';

export const Industries = () => {
  const { t } = useTranslation('industries');
  const industryData = t('industries', { returnObjects: true });

  const icons = [
    retail,
    credit_cards,
    social,
    books,
    corporate,
    travel,
    doc,
    utilities
  ];

  return (
    <div className='solution-platform'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />
      <OverlapBoxIndustry title='' className=' overlap-box-industry'>
        <p className='industries-text'>{t('introText')}</p>
        <div className='cards-div-industries'>
          {industryData.map((item, idx) => (
            <LargeCard key={idx} img={icons[idx]} title={item.title} desc={item.desc} />
          ))}
        </div>
      </OverlapBoxIndustry>
      <Getstarted />
      <Footer />
    </div>
  );
};

const LargeCard = ({ img, desc, title }) => {
  return (
    <div className='largeind-card'>
      <img src={img} className='large-card-img' alt='largeCardImg' />
      <p className='large-card-title'>{title}</p>
      <p className='large-card-desc'>{desc || 'right now description is not available'}</p>
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-industry'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
          Platform / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

const OverlapBoxIndustry = props => {
  return (
    <div className='overlap-box'>
      <p className='box-title'>{props.title}</p>
      {props.children}
    </div>
  );
};
